import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Button, FormGroup, CircularProgress } from '@mui/material';
import { TestDate, defaultTestDate } from '../TestDate.helper';
import testDateService from '../../../../services/TestDateService';
import FormModal, { getResultMessage, ModalMessageSettings } from '../../../Common/FormModal';
import { getStyles } from './styles';

interface DeleteTestDateModalProps {
    open: boolean;
    testDate: TestDate,
    handleClose: (testDateHasChange: boolean) => void;
}

export default function DeleteTestDateModal(props: DeleteTestDateModalProps) {
    const theme = useTheme();
    const styles = getStyles(theme);
    const [ isLoading, setLoading ] = useState(false);
    const [ testDate, setTestDate ] = useState<any>(defaultTestDate);
    const [ modalMessage, setModalMessage ] = useState<ModalMessageSettings>();
    const [ testDateDeletedSuccessfully, setTestDateDeletedSuccessfully ] = useState<boolean>(false);
    
    useEffect(() => {
        if(props.testDate) setTestDate(props.testDate);
    }, [ props.testDate ]);

    const submitForm = async () => {
        setLoading(true);
        const result = await testDateService.deleteTestDate(testDate.id);        
        if(result) {
            setTestDateDeletedSuccessfully(true);
        }
        setLoading(false);
        
        const message = getResultMessage(
        result,
        `Test date deleted successfully!`,
        `Failed to delete this test date!`
        );
        setModalMessage(message);
    };

    const handleCloseDelete = () => {
        props.handleClose(testDateDeletedSuccessfully);
        setModalMessage(undefined);
    }

    return (
        <FormModal
            title={`You are about to permanently remove the selected test date!`}
            description="This action cannot be undone."
            isOpen={props.open}
            handleClose={handleCloseDelete}
            message={modalMessage}
        >
            <div>
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    <Button variant="contained" sx={styles.btnDanger} onClick={submitForm} disabled={testDateDeletedSuccessfully}>Delete</Button>
                    <Button variant="contained" onClick={handleCloseDelete} sx={styles.ml2}>Close</Button>
                </FormGroup>
                {isLoading ? <CircularProgress color="primary" /> : undefined}
            </div>
        </FormModal>
    );
}